import { Wallets, walletsMap } from '@/shared/constants/wallets'

const isProduction = process.env.NEXT_PUBLIC_ENV_STAGE === 'production'

export const WALLET_DEFINITIONS = [
  { kind: Wallets.Ledger, label: walletsMap[Wallets.Ledger] },
  ...(isProduction ? [] : [{ kind: Wallets.WalletConnect, label: walletsMap[Wallets.WalletConnect] }]),
]
